import React from 'react'
import Layout from '../../components/layout'
import { ContainerXl } from '../../components/Containers/containers'
import PageHeader from '../../components/PageHeader'
import { Box, Heading } from '@chakra-ui/react'
import CustomImage from '../../uielements/Image'
import Attachments from '../commonSections/attachments'
import PageGallery from '../commonSections/gallery'
import PageAccordion from '../commonSections/accordion'
import PageBody from '../commonSections/body'
import RelatedPosts from '../../sections/RelatedPosts'
import GoogleMapComponent from '../../components/GoogleMapComponent'

const PageBottomFeatImage = ({ context, page }) => {
    return (
        <Layout>
            <PageHeader title={page.title} subtitle={page?.subtitle} featImg={page?.featuredImage} />
            <PageBody page={page} />
            {page?.featuredImage && (
                <ContainerXl mt={12} mb={12}>
                    <Box borderRadius={28}>
                        <CustomImage obj={page.featuredImage} borderRadius={28} fit={'contain'} />
                    </Box>
                </ContainerXl>
            )}
            {
                context.slug === 'epikoinonia' &&
                <Box>
                    <ContainerXl>
                        <Heading as={'h2'} mb={10}>
                            GOOGLE MAPS
                        </Heading>
                    </ContainerXl>
                    <GoogleMapComponent />
                </Box>
            }
            <PageAccordion page={page} />
            <RelatedPosts blogCategory={page?.blogCategory} blogTags={page?.blogTags} />
            <Attachments attachments={page?.attachments} />
            <PageGallery gallery={page?.gallery} />
        </Layout>
    )
}

export default PageBottomFeatImage
